<p class="italic">
  Reverie is a collection of digital art made by artist Pandelune. It is
  currently published and available for minting on <a
    href="https://prohibition.art/project/reverie-1">Prohibition</a
  >.
</p>
